import { actions } from "@mixitone/actions";

const portalFunctions = actions.playerPortal;
export default portalFunctions;
